import(/* webpackMode: "eager" */ "C:\\var\\coverz_ui\\src\\app\\(auth)\\layout.tsx");
